module.exports = __webpack_public_path__ + "public/media/creator-vector3.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-vector3.png
// module id = ./images/services/creator-vector3.png
// module chunks = 0